<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">محادثات خدمة العملاء</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">محادثات خدمة العملاء</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header">
                <div class="row">
                  <div class="col text-start">
                    <div class="card-title">المحادثات</div>
                  </div>
                  <div class="col text-end">
                    <button class="btn btn-warning btn-sm" :disabled="refreshLoader" @click.prevent="refreshChats"><i class="fa-solid fa-arrows-rotate"></i> تحديث</button>
                  </div>
                </div>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div v-if="checkAccess('chat_contact_us')" class="col">
                    <div class="row">
                      <div class="col-12 col-sm-4">
                        <ol class="list-group list-group-numbered">
                          <li v-for="row in rows" :key="row.id" class="list-group-item d-flex justify-content-between align-items-start">
                            <a href="#" @click.prevent="getChannel(row.cid)" class="a-no-css d-block w-100">
                              <div class="ms-2 me-auto">
                                <div class="fw-bold">{{ row.data.created_by.name }}</div>
                                <div class="date-format">{{ formatDate(row.data.last_message_at)  }}</div>
                              </div>
                              <span v-if="row.state.messages && row.state.messages.length == 1" class="badge text-bg-secondary rounded-pill chat-padge">جديد</span>
                              <span v-if="row.state.unreadCount > 0" class="badge text-bg-secondary rounded-pill chat-padge">{{ row.state.unreadCount }}</span>
                            </a>
                          </li>
                        </ol>
                      </div>

                      <div class="col-12 col-sm-8">
                        <div v-if="!currentChat" class="no-chat-selected">
                          <i class="fa-regular fa-comments"></i>
                        </div>
                        <div v-if="currentChat">
                          <div id="main-chat-div" class="chat-selected border-start p-2">
                            <div v-for="message in currentChatMessages" :key="message.id">
                              <div class="row mb-3" :style="(message.user.role == 'user')? 'direction: ltr;' : ''">
                                <div class="col-auto">
                                  <div class="chat-img" :style="`background-image: url(${(message.user.image && message.user.image != 'https://backend.aqaralmuhaysini.com/uploads/')? message.user.image : '/images/user.png'})`"></div>
                                </div>
                                <div class="col pt-2">
                                  <strong v-if="message.user.role == 'user'" style="cursor: pointer;" @click="getUserInfo(message.user.id)">{{ message.user.name }}</strong>
                                  <strong v-else>{{ message.user.name }}</strong>
                                  <p>{{ message.text }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="border p-2">
                            <form action="" @submit.prevent="sendMessage">
                              <div class="row">
                                <div class="col">
                                  <input type="text" v-model="messageText" class="form-control">
                                </div>
                                <div class="col-auto">
                                  <input type="submit" class="btn btn-warning" value="ارسل">
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!checkAccess('chat_contact_us')" class="col">
                    <div class="alert alert-danger">لا تملك صلاحية للدخول لهذه الصفحة</div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
    <div id="user-info-card" class="modal" tabindex="-1">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">بيانات العميل</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeUserModal"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div v-if="getUserLoader" class="col-12 text-center">
                <loader />
              </div>
              <div v-else class="col-12">
                <errorAlert v-if="userHasError" :alertMessage="message" :errorNumber="errorNumber" />
                <div v-if="userInfo" class="text-center">
                  <div class="mb-3">
                    <router-link :to="`/clients/update/${userInfo.id}`">{{ userInfo.name }}</router-link>
                  </div>
                  <div>
                    <a :href="`https://wa.me/966${parseInt(userInfo.mobile)}`" target="_blank" rel="noopener" class="text-decoration-none me-2" title="مراسلة عبر الواتساب">
                      <i class="bi bi-whatsapp text-success me-1"></i>
                    </a>
                    {{ userInfo.mobile }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { toast, checkAccess, formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'ChatCannelList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      currentChat: null,
      currentChatCID: null,
      currentChatMessages: [],
      messageText: '',
      messageLoader: false,
      channelMessageEvent: null,
      chatMessageEvent: null,
      channelNewChannelEvent: null,
      refreshLoader: false,
      getUserLoader: false,
      userInfo: null,
      userHasError: false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GET_USER_DATA', 'LOADING', 'CHAT_CLIENT'])
  },
  methods: {
    checkAccess,
    formatDate,
    getList(){
      // this.mainLoading = true;
      this.hasError = false;
      this.refreshLoader = true;
      const filter = {type: "messaging", last_message_at: {$exists: true}, team: {$eq: 'contactUs'}};
      const sort = [{ last_message_at: -1 }];
      const rowsPerPage = 30;
      const offset = (this.currentPage == 1)? 0 : (this.currentPage * rowsPerPage) - 1;
      const options = {
        limit: rowsPerPage, offset: offset, // watch: true, state: true
      };
      this.CHAT_CLIENT.queryChannels(filter, sort, options).then(rows => {
        this.rows = rows;
        this.channelMessageEvent = this.CHAT_CLIENT.on("message.new", (event) => {
          if(this.currentChatCID != event.cid){
            // this.chatClient.off("message.new");
            this.channelMessageEvent.unsubscribe();
            if(this.channelNewChannelEvent)
                this.channelNewChannelEvent.unsubscribe();
            this.getList();
          }
        });
        this.channelNewChannelEvent = this.CHAT_CLIENT.on("notification.added_to_channel", (event) => {
          this.channelNewChannelEvent.unsubscribe();
          if(this.channelMessageEvent)
            this.channelMessageEvent.unsubscribe();
          this.getList();
        });
        this.mainLoading = false;
        this.refreshLoader = false;

        // this.chatClient.on("notification.added_to_channel", (event) => {
        //   const newChannel = event.channel;

        //   console.log("Added to new channel:", newChannel);
        //   toast('يوجد محادثة جديدة في خدمة العملاء', 'info');
        //   // Add it to your channel list
        //   // channelList.value.unshift(
        //   //   chatClient.channel(newChannel.type, newChannel.id)
        //   // );
        // });
      }).catch(err => {
        this.message = err.message;
        this.hasError = true;
        this.refreshLoaderr = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getChannel(cid){
      if(this.chatMessageEvent)
        this.chatMessageEvent.unsubscribe();
      this.currentChatCID = cid;
      this.currentChat = null;
      this.currentChatMessages = [];
      this.hasError = false;
      const filter = {type: "messaging", cid: {$eq: cid}};
      const sort = [{ last_message_at: -1 }];
      const options = {
        limit: 1, // watch: true,
      };
      this.CHAT_CLIENT.queryChannels(filter, sort, options).then(async row => {
        // console.log("channel");
        // console.log(row[0].state.members);
        this.currentChat = row[0];
        this.currentChatMessages = row[0].state.messages;
        setTimeout(() => this.chatScroll(), 200);
        if(row[0].state.members[this.GET_USER_DATA.streamId] == undefined)
          this.currentChat.addMembers([this.GET_USER_DATA.streamId]);

        await this.currentChat.watch();
        await this.currentChat.markRead();

        this.chatMessageEvent = this.currentChat.on("message.new", (event) => {
          this.currentChatMessages = this.currentChat.state.messages;
          this.chatScroll();
          // if(event.user.id != this.GET_USER_DATA.streamId){
          // }
        });
      }).catch(err => {
        this.message = err.message;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    chatScroll(){
      const div = document.getElementById('main-chat-div');
      if(div){
        setTimeout(() => {
          div.scrollTo({
            top: div.scrollHeight,
            behavior: 'smooth'
          });
        }, 200);
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    async connecting(){
      this.mainLoading = true;
      this.hasError = false;
      if(this.LOADING){
        setTimeout(() => this.connecting(), 200);
        return;
      }
      if(!this.GET_USER_DATA.streamToken){
        this.message = 'يرجى تسجيل الخروج وإعادة تسجيل الدخول';
        this.hasError = true;
        return;
      }
      if(!this.CHAT_CLIENT){
        this.message = 'خطأ في الإتصال بالمحادثات';
        this.hasError = true;
        return;
      }
      this.getList();
    },
    sendMessage(){
      if(!this.messageText || this.messageText.trim() == ''){
        toast('يجب كتابة الرسالة اولاً');
        return false;
      }
      if(!this.currentChat){
        toast('يجب اختيار المحادثة اولاً');
        return false;
      }
      this.messageLoader = true;
      this.currentChat.sendMessage({
        text: this.messageText,
      }).then(() => {
        this.messageText = '';
        this.messageLoader = false;
      }).catch(err => {
        toast('غير قادر على إرسال الرسالة');
        this.messageLoader = false;
        console.log(err.message);
      });
    },
    refreshChats(){
      if(this.chatMessageEvent)
        this.chatMessageEvent.unsubscribe();
      this.currentChatCID = null;
      this.currentChat = null;
      this.currentChatMessages = [];
      this.getList();
    },
    getUserInfo(userId){
      if(!userId)
        return;
      const card = document.getElementById('user-info-card');
      this.getUserLoader = true;
      this.userInfo = null;
      this.userHasError = false;
      card.style.display = 'block';
      this.$http.post('/api/admin/users/getUserByStreamId', {streamId: userId}).then(({data}) => {
        this.userInfo = data.user;
        this.getUserLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.userHasError = true;
        this.getUserLoader = false;
      });
    },
    closeUserModal(){
      document.getElementById('user-info-card').style.display = 'none';
    },
  },
  created(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.connecting();
  },
  unmounted(){
    if(this.channelMessageEvent)
      this.channelMessageEvent.unsubscribe();
    if(this.chatMessageEvent)
      this.chatMessageEvent.unsubscribe();
    if(this.channelNewChannelEvent)
      this.channelNewChannelEvent.unsubscribe();
  }
}
</script>
